export async function blobToBase64DataString(blob: Blob) {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      const base64data = reader.result as string;
      resolve(base64data.split(',')[1]); // Remove the data URL prefix
    };

    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}
